const configuredHubModuleIds = String(process.env.REACT_APP_HUB_MODULE_IDS || '')
  .split(',')
  .map(value => value.trim())
  .filter(Boolean);

export const isHubModule = (
  { moduleCode, moduleId } = {},
  { fallbackModuleIds = configuredHubModuleIds } = {}
) => {
  const normalizedCode = String(moduleCode || '').trim().toUpperCase();

  // Il codice e' il criterio autorevole: un codice esplicito non-HUB non deve
  // mai essere sovrascritto da un ID eventualmente riutilizzato in un ambiente.
  if (normalizedCode) {
    return normalizedCode === 'HUB';
  }

  if (moduleId === null || moduleId === undefined || moduleId === '') {
    return false;
  }

  const normalizedId = String(moduleId).trim();
  return fallbackModuleIds.map(String).includes(normalizedId);
};

export const getModuleContextFromOptions = (moduleId, moduleOptions = []) => {
  if (moduleId === null || moduleId === undefined || moduleId === '') {
    return { moduleId: null, moduleCode: null };
  }

  const option = moduleOptions.find(item => String(item?.value) === String(moduleId));

  return {
    moduleId,
    moduleCode: option?.original?.MOD_CodiceModulo || option?.label || null,
  };
};

